export const updateQuiz = (payload?: any) => ({
    type: "@saga/UPDATE_QUIZ",
    payload
});

